import axios from 'axios';
import qs from 'qs';
import moment from "moment";
import it from "element-ui/src/locale/lang/it";
export default {
    state: {
        history: []
    },
    mutations: {
        set_history: (state, payload) => {
            state.history = payload;
        }
    },
    actions: {
        get_history: async (ctx, payload) => {
            const self = this;
            await axios(process.env.VUE_APP_BACKEND_HOST + "/api/notifications", {
                method: 'post',
                withCredentials: true,
                headers : {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(
                function(response) {
                    if (response.status === 200 && response.data.status === "success") {
                        const history = response.data.result;
                        ctx.commit('set_history', history);
                    }
                }
            );
        }
    },
    getters: {
        getHistory(state) {
            const newHistory = [];
            for (let index in state.history) if (state.history.hasOwnProperty(index)) {
                const item = state.history[index];
                const newLangs = item.new_data.language_versions;

                if (newLangs[0].language > newLangs[1].language) {
                    item.new_data.language_versions = newLangs.reverse();
                }

                if (item.old_data) {
                    const oldLangs = item.old_data.language_versions;
                    if (oldLangs[0].language > oldLangs[1].language) {
                        item.old_data.language_versions = oldLangs.reverse();
                    }
                }

                newHistory.push(item);
            }

            return newHistory;
        }
    }
}